import { render, staticRenderFns } from "./picStyle.vue?vue&type=template&id=2273d478&scoped=true&"
import script from "./picStyle.vue?vue&type=script&lang=js&"
export * from "./picStyle.vue?vue&type=script&lang=js&"
import style0 from "./picStyle.vue?vue&type=style&index=0&id=2273d478&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273d478",
  null
  
)

export default component.exports